// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA5pFEBbUU3pdJbWurrH2QgBnLQwFXd0GM",
  authDomain: "uif-mortgage.firebaseapp.com",
  projectId: "uif-mortgage",
  storageBucket: "uif-mortgage.appspot.com",
  messagingSenderId: "790878490036",
  appId: "1:790878490036:web:0387cdcd343902dd1d36e1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);

export { app };

